import { avatarsRows } from "../data/avatarsData";

export const writeGroupAvatars = (avatar, setAvatar, scale = 1) =>
  avatarsRows.map((e, mIndex) => (
    <div key={mIndex} className="centerBox" style={{ flexDirection: "row" }}>
      {e.map((o, index) => {
        const newPos = e.length * Number(mIndex) + Number(index) + 1;
        const selected = avatar === newPos;
        return (
          <div
            key={index}
            style={{
              width: 75 * scale,
              height: 65 * scale,
            }}
          >
            <img
              src={o}
              alt={"avatar"}
              className={"avaSelected"}
              onClick={() => {
                setAvatar(newPos);
              }}
              style={{
                width: 75 * scale,
                transform: selected ? "scale(1.3)" : "scale(1)",
                zIndex: selected ? 1 : 0,
                filter: selected
                  ? "drop-shadow(3px 2px 2px rgb(70, 70, 70))"
                  : "drop-shadow(0px 0px 0px rgb(150, 150, 150))",
              }}
            />
          </div>
        );
      })}
    </div>
  ));
